import { request } from "apis/base";
import { InventoryCreateRequestType, InventoryParamsType, InventoryUpdateRequestType } from "constants/types/inventory";

type InventoryExportParams = Pick<InventoryParamsType, "search" | "warehouseId" | "productId">;

export const inventoryApi = {
  getAll: (params?: InventoryParamsType) => {
    return request({ url: "/inventory", method: "GET", params });
  },

  export: (params?: InventoryExportParams) => {
    return request({ url: "/inventory/export", method: "GET", params, responseType: "blob" });
  },

  getById: (id: string) => {
    return request({ url: `/inventory/${id}`, method: "GET" });
  },

  create: (data: InventoryCreateRequestType) => {
    return request({ url: "/inventory", method: "POST", data });
  },

  update: (id: string, data: InventoryUpdateRequestType) => {
    return request({ url: `/inventory/${id}`, method: "PUT", data });
  },

  delete: (id: string) => {
    return request({ url: `/inventory/${id}`, method: "DELETE" });
  },
};
